"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axiosClient_1 = __importDefault(require("./axiosClient"));
const qs_1 = __importDefault(require("qs"));
const localConsole_1 = __importDefault(require("../utils/localConsole"));
const axios_1 = __importDefault(require("axios"));
const checkUserAgent_1 = require("../utils/checkUserAgent");
const header = {
    "content-type": "application/x-www-form-urlencoded",
    // device: checkDevice(),
};
const req = {
    // 더 많은 옵션 : https://axios-http.com/kr/docs/req_config
    // 응답 스키마 : https://axios-http.com/kr/docs/res_schema
    getAdUrl() {
        const pa = { mode: "url", type: "request" };
        const response = axiosClient_1.default.post(`/ad/`, qs_1.default.stringify(pa), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    getAd(url) {
        const params = {
            mode: "NEW",
            ad_inven: "ad_main_popup",
            type: "popup",
        };
        const response = axiosClient_1.default.get(url + "?" + qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    recommendDistrict() {
        // Promise<AxiosResponse<any, any>>
        const response = axiosClient_1.default.post("/recommend/", qs_1.default.stringify({ mode: "district" }), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    recommendLocation(params) {
        params.mode = "location";
        if (params.lat && params.lng) {
            if (params.lat >= 42.5 ||
                params.lat <= 33 ||
                params.lng >= 131.5 ||
                params.lng <= 124.1) {
                params.lat = "";
                params.lng = "";
            }
        }
        const response = axiosClient_1.default.post("/recommend/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    recommendHome(params) {
        params.mode = "home";
        // 기기별로 다른 사이즈로 이미지를 받음
        params.device = (0, checkUserAgent_1.checkDevice)();
        if (params.lat && params.lng) {
            if (params.lat >= 42.5 ||
                params.lat <= 33 ||
                params.lng >= 131.5 ||
                params.lng <= 124.1) {
                params.lat = "";
                params.lng = "";
            }
        }
        const recomHomeParams = {
            lat: params.lat,
            lng: params.lng,
            page: params.page,
            region: params.region,
            token: params.token,
            session: params.session,
            mode: params.mode,
            device: params.device,
        };
        const response = axiosClient_1.default.post("/recommend/", qs_1.default.stringify(recomHomeParams), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
        });
        return response;
    },
    recommendDetail(params) {
        params.mode = "detail";
        if (params.lat && params.lng) {
            if (params.lat >= 42.5 ||
                params.lat <= 33 ||
                params.lng >= 131.5 ||
                params.lng <= 124.1) {
                params.lat = "";
                params.lng = "";
            }
        }
        localConsole_1.default?.log(params, "params");
        const response = axiosClient_1.default.post("/recommend/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    recommendGetShare(params) {
        params.mode = "share";
        params.v_rid = JSON.stringify(params.v_rid);
        if (params.lat && params.lng) {
            if (params.lat >= 42.5 ||
                params.lat <= 33 ||
                params.lng >= 131.5 ||
                params.lng <= 124.1) {
                params.lat = "";
                params.lng = "";
            }
        }
        const response = axiosClient_1.default.post("/recommend/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    recommendSetShare(params) {
        params.mode = "share";
        if (params.lat && params.lng) {
            if (params.lat >= 42.5 ||
                params.lat <= 33 ||
                params.lng >= 131.5 ||
                params.lng <= 124.1) {
                params.lat = "";
                params.lng = "";
            }
        }
        const response = axiosClient_1.default.post("/recommend/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    searchDistrict(params) {
        params.mode = "district";
        const response = axiosClient_1.default.post("/isearch/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    searchPortal(params) {
        params.mode = "portal";
        const response = axiosClient_1.default.post("/isearch/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    userName(TOKEN) {
        const response = axiosClient_1.default.post("/user/", qs_1.default.stringify({ mode: "name", token: TOKEN, private_flag: 0 }), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    favoritesRestaurant(params) {
        params.mode = "restaurant";
        const response = axiosClient_1.default.post("/favorites/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    reportNew(params) {
        params.mode = "new";
        const response = axiosClient_1.default.post("/report/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    autoCompleteSearch(params, AbortSignal) {
        const response = axios_1.default.post("https://autocomp.diningcode.com/autocomp_comb", qs_1.default.stringify(params), {
            headers: header,
            timeout: 4000,
            // signal: AbortSignal,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
        });
        return response;
    },
    contactMail(params) {
        params.mode = "mail";
        const response = axiosClient_1.default.post("/contact/", qs_1.default.stringify(params), {
            headers: header,
            // timeout: 5000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
            // alert("서버 호출에 실패하였습니다.");
        });
        return response;
    },
    sendErrorLogToApi(params) {
        const response = axiosClient_1.default.post("/log/", qs_1.default.stringify(params), {
            headers: header,
            timeout: 10000,
        });
        response.catch((e) => {
            localConsole_1.default?.error(e);
        });
        return response;
    }
};
// export const magazineAD = () => {
//   const dd = JSON.stringify({
//     mode: "NEW",
//     ad_inven: "ad_main_popup",
//     type: "popup",
//   });
//   const response = axios.post(
//     "https://dev-www.diningcode.com/2018/ajax/ad.php",
//     QueryString.stringify({
//       jData: dd,
//     }),
//     {
//       headers: header,
//       timeout: 10000,
//     }
//   );
//   response.catch((e) => {
//     localConsole.error(e);
//     // alert("서버 호출에 실패하였습니다.");
//   });
//   return response;
// };
exports.default = req;
